import React from 'react'

interface Props {
	balloonPosition: { top: string; left: string }
	counter: number
}

const Balloon: React.FC<Props> = ({ balloonPosition, counter }) => {
	return (
		<div className="balloon" style={balloonPosition}>
			<div className="balloon flex-center" id="ballon">
				<span>{counter}</span>
			</div>
		</div>
	)
}

export default Balloon
